export function post(url, data = {}) {
    if (data instanceof HTMLFormElement) data = Object.fromEntries(new FormData(data));
    data.csrf_token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.text())
        .then(text => {
            try {
                return JSON.parse(text);
            } catch (error) {
                return text;
            }
        })
}

Element.prototype.shake = function () {
    this.classList.add('shake');

    this.addEventListener('animationend', () => {
        this.classList.remove('shake');
    }, {once: true});
}